'use client';

import { TableCellStyled } from './table-cell.styles';

export default TableCellStyled;
